export const ApplicationConstant = {
    ApplicationID : 20,
    clientId : 12,
    organizationId: 78,
    DEFAULT_DATE_FORMAT: 'YYYY-MM-DD',
    KWAppID: 19
}